const InternationalTvDramas = [
    {
      id: 1,
      title: "Ghost Doctor",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdRQZvU5-NPY_s1j3M7s9zEPSfOTQ7Q7FRaLdt5iqR26uFg59zQ6_c28Gtg3IiySIiBQ5DtvqoCm21xcsJ0ucnwo2bzIgOvpbgs.jpg?r=b28",
    },
    {
      id: 2,
      title: "All of us are Dead",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABSPxIGcFHASqWvao6j1B_rrLQq_8KBAraWBHPhM2nkHUcJ4KxxpoZjAzLHZqKSC5PAGLOrsBEu7DwCZKleY-Qds20w2q5WXsIyx6JNHeZpeJrowwyIEY8bnDZrjdt13ijRaa.jpg?r=48d",
    },
  
    {
      id: 3,
      title: "School 2017",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdsx5rnbbMxAhuxr32RDNr7YmtOxRiCnEg30R5LeUwW7PEwsyoP0G_QEcZvjauWmJqHONuNRXRoBRvuFTefUYn2W0evyKpfF3RE.jpg?r=54b",
    },
    {
      id: 4,
      title: "3%",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABet4fimTQMGMjNpvEFeO2lIGwAfMfem10fbJoHcM9_cV-0E53aBBIk1RU8B9hvw-NwsQGBUdBxjb9kH73BFbpYqer3GQjs_Olj7I7aQuagBnKpvUGaAfAbanj2V58UKPwdo5.jpg?r=7ab",
    },
  
    {
      id: 5,
      title: "Fishbowl Wives",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABUOA-RkE29DzQMRMBGoPyIXgygNqvetkeKoShopkPQrytPLe07fB-Wu2IR_-_qvhcywk3ey6r0vmOUpe-JYgzXl84X7ScClg7TZOzje74apIGrKQuMZE8VMOMcE2Ic0wqF8B.jpg?r=277",
    },
    {
      id: 6,
      title: "Squid Game",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfGJbm1_V-35fHNttWUtLlNCD6rQZcCDjylPskkQ0wOyZUu7zR5Jr3gTt2yEwQnF6tQyN9tZdrXA2C8vWYmg6bBbMpL-3uHll9xge_9e5ZODFS_LIz6rzn09rPMawNuTMhRk.jpg?r=5e6",
    },
    {
      id: 7,
      title: "Happiness",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/Ahttps://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRHcuOt1CiG7WqH1wdiei7I-sITfwq2dpziu6u-r8f5r3nFnJi8OlMFzJ3WUizsDEYhySWeHrYJhcewYicVXO4gntY0J3byI3y8.jpg?r=e28",
    },
    {
      id: 8,
      title: "Vincenzo",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABVNNvybbYWd1IyW58Fa_AZCBLmHE7EJYV1A9TKK7iUaQ3xq11pzMyUFHIqIGXGzyBB5hPs2WZzP71EFM6wrMK7H77zky8pVxpuCBcDj1wrTPYaKbS_KjYJR2LKB9fj1AOqk_.jpg?r=d92",
    },
    {
      id: 9,
      title: "Boys Over Flowers",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABVWsENVh0-p8i-vEhMwt9jCWF7vSaTnxh4Q_zT3TR-gCiokAVgzd0LhcwxVkKJXzclpJzzKvQwzk6mKGbUedhNpfDYdN_nNectc.jpg?r=b23",
    },
    {
      id: 10,
      title: "Elite",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfgdob6JO25reAsbJ2o7WUj_jjuqsVtjF9NdAm4JOFtYki6a9vMtPmclsNJwPwnuH1MDK1ditb9w5pfkmvNjGEOxg62QKH7Cx36EQ8ojZOd68VZnkOHV5U1rf_wfNEHTb24L.jpg?r=534",
    },
    {
      id: 11,
      title: "Crash Landing On You",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABS-8crU-qv5JocFP-YRozZoh9wav-q8KY0zap0bmP1hT0ja7Sx8unCLctRBWXFfHUHSlbtrwVO8GEGvyMLLivMG9PmEJ1-fQZR0HOgdPDLekHgTxYBz3XaNw3WIQw1vaeGoC.jpg?r=443",
    },
    {
      id: 12,
      title: "Dr. Romantic",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABeq17eXFYFvsKAkpfldCnk1bO1VZG71zo0L_EQuqlYsMJ2mP9iGBV4Azt7h68I8Uiys_nzCVLO49Qh6G2ay535QpG2kG96VFoAA.jpg?r=0e1",
    },
  ];
  
  
  export default InternationalTvDramas;
  